<template>
    <IconSvg viewBox="0 0 48 48" v-bind="$attrs">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M41.6 24C41.6 33.7202 33.7202 41.6 24 41.6C14.2798 41.6 6.4 33.7202 6.4 24C6.4 14.2798 14.2798 6.4 24 6.4C33.7202 6.4 41.6 14.2798 41.6 24ZM44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24ZM26.5 14C26.5 15.3807 25.3807 16.5 24 16.5C22.6193 16.5 21.5 15.3807 21.5 14C21.5 12.6193 22.6193 11.5 24 11.5C25.3807 11.5 26.5 12.6193 26.5 14ZM20.25 19V20.25H22.75V34H20.25V35.25H29V34H26.5V19H20.25Z"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
